import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
function AnimatedCounter({
  value,
  suffix = ''
}: {
  value: number;
  suffix?: string;
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (isInView) {
      let start = 0;
      const duration = 2000; // 2 seconds
      const increment = value / (duration / 16);
      const timer = setInterval(() => {
        start += increment;
        if (start >= value) {
          setCount(value);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 16);
      return () => clearInterval(timer);
    }
  }, [isInView, value]);
  return <span ref={ref} data-id="element-203">
      {count.toLocaleString('de-DE')}
      {suffix}
    </span>;
}
export function TrustSection() {
  const stats = [{
    value: 13,
    suffix: '+',
    label: 'Zahnärzte & Spezialisten'
  }, {
    value: 20,
    suffix: '+',
    label: 'Jahre Erfahrung'
  }, {
    value: 50000,
    suffix: '+',
    label: 'Behandlungen'
  }, {
    value: 3,
    suffix: '',
    label: 'FOCUS Top Mediziner'
  }];
  return <section className="py-24 bg-beige relative border-y border-sand" data-id="element-204">
      <div className="max-w-7xl mx-auto px-6" data-id="element-205">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8 divide-x-0 md:divide-x divide-sand" data-id="element-206">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="text-center px-4" data-id="element-207">
              <div className="text-4xl md:text-5xl font-heading text-gold mb-2" data-id="element-208">
                <AnimatedCounter value={stat.value} suffix={stat.suffix} data-id="element-209" />
              </div>
              <div className="text-sm md:text-base text-schwarz font-body font-medium" data-id="element-210">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}